import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";
import commonStyles, { breadCrumbsTextColor, breadCrumbsTextSize,  breadCrumbsTextFont } from "styles/common";

const useStyles = makeStyles()((theme: any) => ({
    root: {
        height: 40,
        width: "100%",
        paddingLeft: 12,
        paddingTop: 12,
        cursor: "pointer",
    },
    label: {
        //color: breadCrumbsTextColor,
        fontSize : '14px',
        fontWeight : 400,//breadCrumbsTextFont,
        display: 'block',
        " &:not(.mainTitle)": {
            letterSpacing: '-0.025em',
            textTransform: 'capitalize',
            //maxWidth: '20rem'
        },
        " &.link": {
            cursor: "pointer",
            " &:hover": {
                textDecoration: "underline"
            }
        },
    },
    icon: {
        color: breadCrumbsTextColor,
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    arrow: {
        padding: "0 9px 0 7px",
        color: "#9c9c9c",
        fontSize: 11,
    },
    mainTitle: {
        color: breadCrumbsTextColor,
        fontSize : breadCrumbsTextSize,
        fontWeight : 400,
    }
}));

type IProps = {
    label: string;
    image?: any;
    className?: string;
    onClick?: (evt: any) => void;
    hideArrow?: boolean;
    hidden?: boolean;
};

export default function PathLabel(props: IProps) {
    //const { classes: common } = commonStyles();
    const { classes } = useStyles();
    const { label, hidden, onClick, className=""} = props;
    return (
            <Typography 
                className={`${className === "mainTitle" ? `${classes.mainTitle} mainTitle` : className} ${classes.label}${onClick?' link':''}`} 
                onClick={onClick} 
                component='span'
                sx={{
                    visibility: !hidden ? 'visible' : 'hidden'
                }}
            >
                {label}
            </Typography>
    );
}
